import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SliderMenuService } from '@digi-web-core/components';
import { AppComponent } from 'src/app/app.component';
import { LoginService } from 'src/app/services/login.service';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

@Component({
  selector: 'app-gettoken',
  templateUrl: './gettoken.component.html',
  styleUrls: ['./gettoken.component.scss']
})
export class GettokenComponent implements OnInit {

  constructor(
    private sliderMenuService: SliderMenuService,
    private loginService: LoginService,
    private router: Router,
    private appComponent: AppComponent,
    private sharedData: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.sharedData.updateData({ isDealerPortal: window.location.href.includes("Dealerportal") });
    // 隐藏菜单
    this.sliderMenuService.hiddenSliderMenu();
     // 从azure返回的url中获取code，向后端请求token信息
     const url = location.href.split('?')[1];
     const kv = url.split('&');
     const mode: any = {};
     for (let i = 0; i < kv.length; i++) {
       const entry = kv[i].split('=');
       mode[entry[0]] = entry[1];
     }
     if (mode.code) {
      if(window.location.href.includes("Salesportal/iam/cart/gettoken")) {
        this.loginService.signinSSO({ code: mode.code, redirectUrl: `${location.origin}/Salesportal/iam/cart/gettoken` });
      } else {
        this.loginService.signinSSO({ code: mode.code, redirectUrl: `${location.origin}/Salesportal/gettoken` });
      }
     }
  }
}
